import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";




const getTourismPolicys = async () => {
  const UserString = localStorage.getItem("user");
  const User = JSON.parse(UserString);
  const id = User.id;
  const response = await axios.get(`${base_url}ppp/${id}/policies`);

  return response.data;

};
const createTourismPolicys = async (formData) => {
  const UserString = localStorage.getItem("user");
  const User = JSON.parse(UserString);
  const id = User.id;
  const response = await axios.post(`${base_url}ppp/${id}/addPolicy`, formData);

  return response.data;
};
const updateTourismPolicy = async (News) => {
  const UserString = localStorage.getItem("user");
  const User = JSON.parse(UserString);
  const id = User.id;
  const formData = new FormData();
  formData.append("policyName", News.NewsData.get("policyName"));
  formData.append("policyDetails", News.NewsData.get("policyDetails"));

  const response = await axios.put(
    `${base_url}ppp/${id}/policies/${News.id}`,
    formData,
    config
  );

  return response.data;
};

const getTourismPolicy = async (idd) => {
  const UserString = localStorage.getItem("user");
  const User = JSON.parse(UserString);
  const id = User.id;
  const response = await axios.get(`${base_url}ppp/${id}/policies/${idd}`, config);

  return response.data;
};

const deleteTourismPolicy = async (idd) => {
  const UserString = localStorage.getItem("user");
  const User = JSON.parse(UserString);
  const id = User.id;
  const response = await axios.delete(`${base_url}ppp/${id}/policies/${idd}`, config);

  return response.data;
};
const TourismPolicyService = {
  getTourismPolicys,
  createTourismPolicys,
  getTourismPolicy,
  updateTourismPolicy,
  deleteTourismPolicy,
};

export default TourismPolicyService;
